import axiosInstance from './api/axiosInstance.js';

export const ticketService = {
  async reserveTickets(packageId, quantity) {
    try {
      const response = await axiosInstance.post(
        `/packages/${packageId}/reserve`,
        { quantity }
      );

      return response.data;
    } catch (error) {
      if (error.response?.status === 409) {
        throw new Error('Sold out or insufficient tickets available');
      } else if (error.response?.status === 401) {
        throw new Error('Please login to reserve tickets');
      } else if (error.response?.status === 400) {
        throw new Error(error.response.data.error || 'Invalid request');
      } else {
        throw new Error('Failed to reserve tickets. Please try again.');
      }
    }
  },

  async getAvailability(packageId) {
    try {
      const response = await axiosInstance.get(`/packages/${packageId}/availability`);
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch availability');
    }
  },

  formatReservationData(reservation) {
    return {
      reservationId: reservation.reservationId,
      expiresAt: new Date(reservation.expiresAt),
      available: reservation.available
    };
  },

  getTimeRemaining(expiresAt) {
    const now = new Date();
    const expiry = new Date(expiresAt);
    const diff = expiry - now;
    
    if (diff <= 0) {
      return { expired: true, minutes: 0, seconds: 0 };
    }
    
    const minutes = Math.floor(diff / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
    
    return { expired: false, minutes, seconds };
  }
};
